import { render, staticRenderFns } from "./Spec.vue?vue&type=template&id=21b59264"
import script from "./Spec.vue?vue&type=script&lang=ts"
export * from "./Spec.vue?vue&type=script&lang=ts"
import style0 from "./Spec.vue?vue&type=style&index=0&id=21b59264&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports